import React, { useEffect, ReactElement, useRef, useReducer } from "react";
import {
  FormTab,
  TextInput,
  required,
  SelectInput,
  Record,
  TabbedForm,
} from "react-admin";
import { useAppData } from "../../../common/hooks/useAppData";
import { GroupMembersSelector } from "./GroupMembersSelector";
import {
  DriverDto,
  VehicleDto,
  GroupListDto,
  GroupDto,
} from "../../../common/data/service-proxies";
import { groupMembersReducer } from "./context";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface GroupFormProps {
  record?: GroupListDto & GroupDto & Record;
  toolbar?: ReactElement;
}

export const GroupForm = (props: GroupFormProps) => {
  const companies = useAppData((x) => x.companies) ?? [];
  const creatorUserDisplayNameRef = useRef<string>();
  const [state, dispatch] = useReducer(groupMembersReducer, {
    selectedDrivers: [],
    selectedVehicles: [],
  });

  useEffect(() => {
    // To fix he difference between the list and form models
    if (!props.record) {
      return;
    }

    if (props.record.drivers) {
      props.record.driverIds = props.record.drivers.map(
        (x: DriverDto) => x.id!
      );
    }

    if (props.record.vehicles) {
      props.record.vehicleIds = props.record.vehicles.map(
        (x: VehicleDto) => x.id!
      );
    }

    if (props.record.creatorUserDisplayName) {
      creatorUserDisplayNameRef.current = props.record.creatorUserDisplayName;
    }

    if (creatorUserDisplayNameRef.current) {
      props.record.creatorUserDisplayName = creatorUserDisplayNameRef.current;
    }
  }, [props.record]);

  const defaultCompany = companies.length === 1 ? companies[0] : undefined;

  return (
    <TabbedForm className="form-create-edit" variant="outlined" {...props}>
      <FormTab label="resources.admin-groups.labels.general">
        <ProtectedElement source="name">
          <TextInput
            source="name"
            label="resources.admin-groups.labels.name"
            validate={required()}
          />
        </ProtectedElement>
        <ProtectedElement source="companyId">
          <SelectInput
            source="companyId"
            label="resources.admin-groups.labels.company"
            choices={companies}
            validate={required()}
            defaultValue={defaultCompany?.id}
          />
        </ProtectedElement>
      </FormTab>
      <FormTab label="resources.admin-groups.labels.groupMembers">
        <GroupMembersSelector state={state} dispatch={dispatch} />
      </FormTab>
    </TabbedForm>
  );
};
